import type { IButtonStyles } from '@fluentui/react';
import type { RibbonControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/Controls/RibbonControlProps';
import { computedFn } from 'mobx-utils/lib/computedFn';
import {
    createAppButton,
    createAppFlyoutAnchor,
    getKeytipString,
    constructKeytip,
} from 'owa-command-ribbon';
import type RibbonViewState from 'owa-editor-ribbonplugin-store/lib/store/schema/RibbonViewState';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import Redo from 'owa-fluent-icons-svg/lib/icons/ArrowRedoRegular';
import Undo from 'owa-fluent-icons-svg/lib/icons/ArrowUndoRegular';
import loc from 'owa-localize';
import { FormatControlId } from 'owa-ribbon-ids';
import createWrapper from '../util/controlOnExecuteHandler';
import { redoText, undoText } from './formatControlStrings.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';

export const getUndoRedoControl = computedFn(
    (
        editorViewState: EditorViewState | undefined,
        ribbonViewState: RibbonViewState | undefined,
        styles: IButtonStyles | undefined,
        tabId: number | undefined
    ): RibbonControlProps => {
        return createAppFlyoutAnchor(
            getComposeRibbonId(FormatControlId.UndoRedo, editorViewState),
            loc(undoText),
            {
                sections: [
                    {
                        controls: [
                            createAppButton(
                                getComposeRibbonId(FormatControlId.Undo, editorViewState),
                                loc(undoText),
                                createWrapper(editorViewState, ribbonViewState, () =>
                                    callEditorApi(editorViewState!, 'undo')
                                ),
                                tabId && isFeatureEnabled('mon-ribbon-keytips')
                                    ? constructKeytip(
                                          [
                                              getKeytipString(tabId),
                                              getKeytipString(FormatControlId.UndoRedo),
                                          ],
                                          getKeytipString(FormatControlId.Undo)
                                      )
                                    : undefined,
                                Undo,
                                undefined /* iconColor */,
                                styles
                            ),
                            createAppButton(
                                getComposeRibbonId(FormatControlId.Redo, editorViewState),
                                loc(redoText),
                                createWrapper(editorViewState, ribbonViewState, () =>
                                    callEditorApi(editorViewState!, 'redo')
                                ),
                                tabId && isFeatureEnabled('mon-ribbon-keytips')
                                    ? constructKeytip(
                                          [
                                              getKeytipString(tabId),
                                              getKeytipString(FormatControlId.UndoRedo),
                                          ],
                                          getKeytipString(FormatControlId.Redo)
                                      )
                                    : undefined,
                                Redo,
                                undefined /* iconColor */,
                                styles
                            ),
                        ],
                    },
                ],
            },
            tabId && isFeatureEnabled('mon-ribbon-keytips')
                ? constructKeytip(
                      [getKeytipString(tabId)],
                      getKeytipString(FormatControlId.UndoRedo),
                      true
                  )
                : undefined,
            Undo,
            undefined /* iconColor */,
            styles
        );
    }
);
